import type { Reducer } from 'redux';
import { List } from 'immutable';

import { CREATE_GIFT_CARD, REMOVE_GIFT_CARD, SET_GIFT_CARDS, SET_IS_CARDS_LOADING, UPDATE_GIFT_CARD } from './types';
import { MyGiftCardsActionsType } from './action';
import { ShortBrandedGiftCard } from 'features/my-gift-cards/ts/ShortBrandedGiftCard';
import { LOGOUT_SUCCESS } from 'features/auth/redux/types';

export interface MyGiftCardsState {
  cards?: List<ShortBrandedGiftCard>;
  isLoading: boolean;
}

export const INITIAL_STATE: MyGiftCardsState = {
  isLoading: false,
};

const messageReducer: Reducer<MyGiftCardsState, MyGiftCardsActionsType> = (
  state = INITIAL_STATE,
  action
): MyGiftCardsState => {
  switch (action.type) {
    case LOGOUT_SUCCESS:
      return INITIAL_STATE;
    case UPDATE_GIFT_CARD:
      return {
        ...state,
        cards: state?.cards?.map(item => (item.id === action.payload.id ? { ...item, ...action.payload } : item)),
      };
    case CREATE_GIFT_CARD:
      return {
        ...state,
        cards: state.cards?.insert(0, action.payload),
      };
    case REMOVE_GIFT_CARD:
      return {
        ...state,
        cards: state?.cards?.filter(card => card.id !== action.payload),
      };
    case SET_IS_CARDS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case SET_GIFT_CARDS:
      return {
        ...state,
        cards: action.payload,
      };
    default: {
      return state;
    }
  }
};

export default messageReducer;
